import { render } from "./Contact.vue?vue&type=template&id=1a1496f1&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a1496f1"

export default script